import axios from '../../../axios';
import DataDownloadSettingsDTO from '../types/DataDownloadSettingsDTO';
export const getDataDownloadSettings = () =>
  axios.get('candidatesearch/api/data-download-settings/CandidateCRM');
export const saveDataDownloadSettings = (payload: DataDownloadSettingsDTO) =>
  axios.post('candidatesearch/api/data-download-settings/', payload);

export const hasDownloadPermissions = () =>
  axios.get('api/plan/feature/usage/CS_DOWNLOAD_CANDIDATE_LIST');

export const saveJobsDataDownloadSettings = (payload: DataDownloadSettingsDTO) =>
  axios.post('/jobsearch/api/data-download-settings/', payload);

export const getJobsDataDownloadSettings = () =>
  axios.get('/jobsearch/api/data-download-settings/');
